// Vocab + presentación de la Transferencia (TE). El backend es dueño de las
// fechas (preñez estimada + dx1, calculadas en el create) y de la entidad
// receptora; esto es solo vocabulario de UI.
// Refs: api-reference/admin-transfer-sessions.md, decisiones 0002 §TE, 0010, 0017.

import { STAGES, STORAGE, stageColor, stageLabel } from './clivage';

// transfer_session_staff.role (decisión 0002 — marcado "por confirmar").
export const TE_ROLES = [
    { value: 'transfer_vet', label: 'Transferencista' },
    { value: 'synchronizer', label: 'Sincronizador' },
    { value: 'assistant',    label: 'Asistente' },
    { value: 'operator',     label: 'Operario' },
];
export const TE_ROLE_LABEL = Object.fromEntries(TE_ROLES.map((r) => [r.value, r.label]));

// Popovers clínicos (estilo v1) → guardados en transfers[].remarks (JSON libre).
// Cuerpo lúteo: lado + calidad (1|2|3, opcional) + cavernoso (solo calidad 1/2).
export const CL_QUALITIES = [1, 2, 3];

// Estado de la receptora al transferir.
export const TE_STATES = [
    { value: 'NV', label: 'NV' },
    { value: 'VP', label: 'VP' },
    { value: 'VS', label: 'VS' },
    { value: 'N/A', label: 'N/A' },
];

// Medicación aplicada.
export const TE_MEDICATIONS = [
    { value: '', label: 'Ninguna' },
    { value: 'sincrogest', label: 'Sincrogest' },
    { value: 'gestar', label: 'Gestar' },
];

// Stack de 15 colores de contraste para distinguir sesiones TE (el subrayado de
// una transferencia usa el color de su sesión). sessionColor cicla con módulo.
export const SESSION_COLORS = [
    '#3bb5ed', '#04c2a0', '#f59e0b', '#a855f7', '#ef4444',
    '#10b981', '#6366f1', '#ec4899', '#14b8a6', '#f97316',
    '#0ea5e9', '#84cc16', '#8b5cf6', '#e11d48', '#0891b2',
];
export function sessionColor(i) {
    const n = SESSION_COLORS.length;
    return SESSION_COLORS[(((i || 0) % n) + n) % n];
}

// Chips de estadio de embrión: única paleta canónica, definida en clivage.js
// (set BE,BN,BX,BL,BI,MO,DG en mayúsculas; lookup case-insensitive).
export const embryoStageLabel = stageLabel;
export const embryoStageColor = stageColor;

// Preservación del embrión = `storage` del contrato (fresh|frozen). El "flag de
// congelado" se deriva de esto (storage === 'frozen'). Etiqueta legible: Fresco/Congelado.
const STORAGE_LABEL = Object.fromEntries(STORAGE.map((s) => [s.value, s.label]));
export const storageLabel = (s) => STORAGE_LABEL[s] || '—';
export const isFrozen = (s) => s === 'frozen';

// Nombre COMPLETO del estadio (estado de maduración) para informes; los chips usan
// el código corto (embryoStageLabel). Ej.: 'bl' → "Blastocisto".
const STAGE_NAME = Object.fromEntries(STAGES.map((s) => [s.value.toUpperCase(), s.label]));
export const stageName = (code) => STAGE_NAME[String(code || '').toUpperCase()] || stageLabel(code);
